/* Shared countdown helpers — milliseconds until the next 00:00 UTC
   (when a new daily puzzle drops worldwide), plus an HH:MM:SS
   formatter. Used by the toolbar PuzzleStatus, the no-puzzle-today
   placeholder, and the post-game NextPuzzleCountdown.

   The target midnight is captured once per page session on first
   call and is then frozen: subsequent calls return max(0, target -
   now), so once the wall clock crosses the boundary every consumer
   freezes at 00:00:00 in lockstep and stays there until reload.
   This is deliberate — auto-rolling the target forward at the
   instant of midnight would (a) flash "24:00:00" for one tick and
   (b) start counting down to *the day after* the new puzzle the
   player is actually waiting for. We'd rather players reload to see
   the next puzzle. */

let frozenTarget: number | null = null;

export function msUntilNextUtcMidnight(now: Date = new Date()): number {
  if (frozenTarget == null) {
    frozenTarget = Date.UTC(
      now.getUTCFullYear(),
      now.getUTCMonth(),
      now.getUTCDate() + 1,
      0,
      0,
      0,
      0,
    );
  }
  return Math.max(0, frozenTarget - now.getTime());
}

/** Test-only: drop the captured target so the next call recomputes
    relative to its `now` argument. Production code should not call
    this — once a player has seen the timer running, freezing is the
    desired behavior for the rest of the session. */
export function _resetFrozenTarget(): void {
  frozenTarget = null;
}

export function formatHms(ms: number): string {
  const totalSec = Math.floor(ms / 1000);
  const h = Math.floor(totalSec / 3600);
  const m = Math.floor((totalSec % 3600) / 60);
  const s = totalSec % 60;
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${pad(h)}:${pad(m)}:${pad(s)}`;
}
